import React from 'react';
import ChartToWorkspace from './ChartToWorkspace';
import WorkspaceDeleteAnalysisModal from './WorkspaceDeleteAnalysisModal';
import { IncidentDeleteModal } from '../../Incidents/IncidentModals';
import Scheduler from '../../Scheduler';
import { ScheduleType } from '../../../utils/apollo/graphqlSchema';
import { useAppSelector } from '../../../redux/hooks';
import { selectOpenedModalType } from '../../../redux/selectors/modal';
import { ModalSliceType } from '../../../redux/slices/modal';
import AddReportToDashboardModal from './AddReportToDashboardModal';
import ShowSQLModal from '../ShowSQLModal';
import { SaveCohortModal } from '../../Cohort';
import RenameReportModal from './RenameReportModal';
import SaveConfirmModal from './SaveConfirmModal';
import AddToScratchpadModal from './AddToScratchpadModal';

interface IProps {
  analysisId: string;
}

const ChartModals = ({ analysisId }: IProps) => {
  const isAddToDashboardModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.AddToDashboard, analysisId),
  );
  const isAddToWorkspaceModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.AddToWorkspace, analysisId),
  );
  const isAddToScratchpadModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.AddToScratchpad, analysisId),
  );
  const isDeleteFromWorkspaceModalOpen = useAppSelector((state) =>
    selectOpenedModalType(
      state,
      ModalSliceType.WorkspaceDeleteReport,
      analysisId,
    ),
  );
  const isDeleteIncidentModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.IncidentDelete, analysisId),
  );
  const isScheduleAnalysisModalOpen = useAppSelector((state) =>
    selectOpenedModalType(
      state,
      ModalSliceType.CreateSchedule,
      `${ScheduleType.Analysis}-${analysisId}`,
    ),
  );
  const isRenameReportModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.RenameReport, analysisId),
  );

  const isSqlViewModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.ShowSql, analysisId),
  );

  const isSaveCohortModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.SaveCohort, analysisId),
  );
  const isSaveConfirmModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.SaveConfirmModal, analysisId),
  );

  if (isAddToDashboardModalOpen) {
    return <AddReportToDashboardModal analysisId={analysisId} />;
  }

  if (isAddToWorkspaceModalOpen) {
    return <ChartToWorkspace analysisId={analysisId} />;
  }

  if (isDeleteFromWorkspaceModalOpen) {
    return <WorkspaceDeleteAnalysisModal analysisId={analysisId} />;
  }

  if (isDeleteIncidentModalOpen) {
    return <IncidentDeleteModal analysisId={analysisId} />;
  }

  if (isScheduleAnalysisModalOpen) {
    return <Scheduler entityId={analysisId} jobType={ScheduleType.Analysis} />;
  }

  if (isSqlViewModalOpen) {
    return <ShowSQLModal />;
  }

  if (isSaveCohortModalOpen) {
    return <SaveCohortModal />;
  }

  if (isRenameReportModalOpen) {
    return <RenameReportModal analysisId={analysisId} />;
  }

  if (isSaveConfirmModalOpen) {
    return <SaveConfirmModal />;
  }

  if (isAddToScratchpadModalOpen) {
    return <AddToScratchpadModal analysisId={analysisId} />;
  }

  return null;
};

export default ChartModals;
